// filepath: /d:/Area de Trabalho/criandoparaweb/site/src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import './styles/tailwind.css';
import '@fortawesome/fontawesome-free/css/all.css';

import { createMetaManager } from 'vue-meta';
import router from './router';

const app = createApp(App);
const metaManager = createMetaManager();

app.use(metaManager);
app.use(router);
app.mount('#app');